import React, { useState } from 'react'
import './ModalBasic.scss'
import { Box, Modal, Typography } from '@mui/material'


export function ModalBasic(props) {

  const {show, title, children, onClose, size, sizeModal} = props;  


  return (
<Modal     
  open={show}
  onClose={onClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"

>
  <Box className={['box__modal', sizeModal]}>
    {title ? <Typography id="modal-modal-title" variant="h6" component="h2">{title}</Typography> : ''}          
    <Box id="modal-modal-description" sx={{ mt: 2 }}>
      {children}
    </Box>
  </Box>
</Modal>
  )
}

